(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["complementary-products"] && !Shopify.designMode) return;
  try {
    if (!window.complementaryRecommendationsInitialized) {
    window.complementaryRecommendationsInitialized = true

    const loadComplementaryRecommendations = (section) => {
      const url = section.dataset.url
      if (!url) return

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div')
          html.innerHTML = text
          const recommendations = html.querySelector('.complementary-product-recommendations')

          if (recommendations && recommendations.innerHTML.trim().length) {
            section.innerHTML = recommendations.innerHTML
          }

          section.querySelectorAll('.scroll-container')
            .forEach(el => window.omgTheme.initScrollIndicators(el))
        })
        .catch((e) => {
          console.error(e)
        })
    }

    const handleIntersection = (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return

        observer.unobserve(entry.target)
        loadComplementaryRecommendations(entry.target)
      })
    }

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: '0px 0px 200px 0px',
    })

    const observeComplementarySections = () => {
      document.querySelectorAll('.complementary-product-recommendations').forEach((section) => {
        if (section.dataset.url && !section.dataset.loaded) {
          section.dataset.loaded = 'true'
          observer.observe(section)
        }
      })
    }

    observeComplementarySections()
    document.addEventListener('shopify:section:load', observeComplementarySections)
  }
  } catch(e) { console.error(e); }
})();

})();
